import { useTranslation } from 'react-i18next';
import { InfluencerPostSection, InfluencerNewProfileHeaderV2 } from '@anytag/graphql';
import {
  eyeBlueImage,
  likePinkImage,
  chatGreenImage,
  videoPinkImage,
  networkBlueImage,
  messageBlueImage,
  chartLightYellowImage,
} from '@anytag/shared-assets';
import { ChartsContainer } from '@anytag/shared-atoms';
import { PostingHabits, AverageEngagement } from '@anytag/shared-molecules';
import { useInfluencerProfileOpacityContent } from '../../../hooks';
import { InfluencerSelectedAccountInfo } from '../../../types';
import { InfluencerProfilePostsOverviewWrapper } from '../../shared';

interface InfluencerThreadsProfilePostsOverviewProps {
  data?: InfluencerPostSection;
  socialAccount: InfluencerSelectedAccountInfo;
  influencerProfile: InfluencerNewProfileHeaderV2;
}

export const InfluencerThreadsProfilePostsOverview = ({
  data,
  socialAccount,
  influencerProfile: { id }
}: InfluencerThreadsProfilePostsOverviewProps) => {
  const { t } = useTranslation();
  const { opacityContent } = useInfluencerProfileOpacityContent({
    socialAccount,
    influencerId: id,
    skipEstimateContent: true
  });

  return (
    <InfluencerProfilePostsOverviewWrapper data={data}>
      <ChartsContainer
        css={{ height: '324px' }}
        elements={[
          <AverageEngagement
            data={[
              {
                icon: videoPinkImage,
                label: t('Avg posts/week'),
                value: data?.averagePostsPerWeek || null
              },
              {
                isPercentage: true,
                icon: chartLightYellowImage,
                value: data?.engagementFollowersRate || null,
                label: t('HeaderColumn.Avg ER')
              },
              {
                icon: likePinkImage,
                value: data?.averageLikes || null,
                label: t('Avg Likes')
              },
              {
                icon: eyeBlueImage,
                value: data?.averageViews || null,
                label: t('Avg Views')
              },
              {
                icon: chatGreenImage,
                value: data?.averageComments || null,
                label: t('Avg Reply')
              },
              {
                icon: networkBlueImage,
                value: data?.averageShares || null,
                label: t('Avg Shares')
              },
              {
                icon: messageBlueImage,
                value: data?.averageReposts || null,
                label: t('Avg Reposts')
              }
            ]}
          />,
          <PostingHabits {...opacityContent} data={data?.postsHabit} />
        ]}
      />
    </InfluencerProfilePostsOverviewWrapper>
  );
};
